import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	user: null,
	error: "",
	loading: false,
};

export const addIndivisualUser = createAsyncThunk("user/addIndivisualUser", async (values) => {
	try {
		const { data } = await axios({
			method: "post",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=UTF-8",
			},
			// url: `user/register`,
			url: `user/indivisualRegister`,
			data: {
				...values,
			},
		});
		toast.success("Registration successful");
		return {
			data,
			message: "success",
		};
	} catch (error) {
		toast.error("Error in adding user try again");
		console.log(error.message);
		return {
			message: "error",
		};
	}
});

export const changePasswordToAdmin = createAsyncThunk(
	"user/changePasswordToAdmin",
	async (values, { rejectWithValue }) => {
	  try {
		const { data } = await axios({
		  method: "post",
		  headers: {
			Accept: "application/json",
			"Content-Type": "application/json;charset=UTF-8",
		  },
		  url: `user/changePasswordToAdmin`,
		  data: values,
		});
  
		toast.success("Password changed to admin successfully");
		return {
		  data,
		  message: "success",
		};
  
	  } catch (error) {
		// Handle different types of errors
		if (error.response) {
		  // Server responded with error
		  const errorMessage = error.response.data.message || "Error changing password";
		  toast.error(errorMessage);
		  return rejectWithValue(errorMessage);
		} else if (error.request) {
		  // Request made but no response
		  toast.error("Network error. Please check your connection");
		  return rejectWithValue("Network error");
		} else {
		  // Something else went wrong
		  toast.error("Error changing password. Please try again");
		  return rejectWithValue("Error changing password");
		}
	  }
	}
  );
  

export const postBankDetails = createAsyncThunk("user/postBankDetails", async (values) => {
	try {
		const { data } = await axios({
			method: "post",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=UTF-8",
			},
			// url: `user/register`,
			url: `user/BankDetails`,
			data: {
				...values,
			},
		});
		toast.success("Bank Details add successful");
		return {
			data,
			message: "success",
		};
	} catch (error) {
		toast.error("Error in adding bank details try again");
		console.log(error.message);
		return {
			message: "error",
		};
	}
});

export const changePassword = createAsyncThunk("user/changePassword", async (values) => {
	try {
		const { data } = await axios({
			method: "post",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=UTF-8",
			},
			url: `user/change-password`,
			data: {
				...values,
			},
		});
		toast.success("Change Password successfully");
		return {
			data,
			message: "success",
		};
	} catch (error) {
		toast.error("Error in Change Password try again");
		console.log(error.message);
		return {
			message: "error",
		};
	}
});

// export const addStaff = createAsyncThunk("user/addStaff", async (values) => {
// 	try {
// 	console.log("slice values", values)
// 		const { data } = await axios({
// 			method: "post",
// 			headers: {
// 				Accept: "application/json",

// 				"Content-Type": "multipart/form-data",
// 			},
// 			url: `user/register`,
// 			// url: `user/indivisualRegister`,
// 			data: {
// 				...values,
// 			},
// 		});
// 		toast.success("Registration successful");
// 		return {
// 			data,
// 			message: "success",
// 		};
// 	} catch (error) {
// 		toast.error("Error in adding staff try again");
// 		console.log(error.message);
// 		return {
// 			message: "error",
// 		};
// 	}
// });

export const addStaff = createAsyncThunk("user/addStaff", async (values) => {
    try {
        console.log("slice values", values);

        // Create a FormData object
        const formData = new FormData();

        // Append all fields from values to FormData
        Object.keys(values).forEach((key) => {
            if (key === "file" && values[key]) {
                // Append the file separately
                formData.append("file", values[key]);
            } else if (typeof values[key] === "object" && values[key] !== null) {
                // Stringify nested objects (e.g., educations, salaryComponents)
                formData.append(key, JSON.stringify(values[key]));
            } else {
                // Append primitive values directly
                formData.append(key, values[key]);
            }
        });

        const { data } = await axios({
            method: "post",
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data", // This is optional; Axios sets it automatically with FormData
            },
            url: `user/register`,
            data: formData, // Send FormData instead of a plain object
        });

        toast.success("Registration successful");
        return {
            data,
            message: "success",
        };
    } catch (error) {
        toast.error("Error in adding staff, try again");
        console.log(error.message);
        return {
            message: "error",
        };
    }
});


export const uploadUsersFromExcel = createAsyncThunk(
	'user/uploadUsersFromExcel',
	async (fileData, { rejectWithValue }) => {
	  try {
		const { data } = await axios.post(
		  'user/upload-excel',
		  fileData, 
		  {
			headers: {
			  'Content-Type': 'multipart/form-data',
			},
		  }
		);
  
		// Check if there are any failed imports
		if (data.results && data.results.failed && data.results.failed.length > 0) {
		  // Display the error message from the failed records
		  const errorMessage = data.results.failed.map(item => item.error).join(', ');
		  toast.error(`Error uploading users: ${errorMessage}`);
		} else {
		  // If everything is successful, show a success message
		  toast.success('User data uploaded successfully');
		}
  
		return data; // Return the data for further use if needed
	  } catch (error) {
		// Handle unexpected errors (e.g., network issues)
		toast.error('Error uploading users');
		return rejectWithValue(error.response?.data || error.message); // Return the error for handling in the reducer
	  }
	}
  );
  
export const deleteStaff = createAsyncThunk("user/deleteStaff", async (id) => {
	try {
		const resp = await axios({
			method: "patch",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=UTF-8",
			},
			url: `user/${id}`,
			data: {
				status: false,
			},
		});
		return resp.data;
	} catch (error) {
		console.log(error.message);
	}
});

export const getBankDetailsByUserId = createAsyncThunk(
	"user/getBankDetailsByUserId",
	async (userId) => {
		try {
			const data = await axios.get(`user/bankDetails/${userId}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const loadSingleStaff = createAsyncThunk(
	"user/loadSingleStaff",
	async (id) => {
		try {
			const data = await axios.get(`user/${id}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const getCompanyNameByClientId = createAsyncThunk(
	"user/getCompanyNameByClientId",
	
	async (id) => {		
	console.log("done");

		try {
			const data = await axios.get(`user/getCompanyNameByClientId/${id}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const loadAllStaff = createAsyncThunk(
	"user/loadAllStaff",
	async ({ status }) => {
		try {
			const { data } = await axios.get(`user?status=${status}`);
			console.log("Loaded Staff Data:", data);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);


export const loadTodaysBirthdays = createAsyncThunk(
	'users/loadTodaysBirthdays',
	async () => {
	  const response = await axios.get('user/birthdays');
	  console.log('API Response>>>>>:', response.data);
	  return response.data;
	}
  );
  

  export const loadUpcomingBirthdays = createAsyncThunk(
	'users/loadUpcomingBirthdays',
	async () => {
	  const response = await axios.get('user/getUpcomingBirthdays');
	  console.log('API Response<<<<<:', response.data);
	  return response.data;
	}
  );

  export const getUserDevices = createAsyncThunk(
	'user/getUserDevices',
	async () => {
	  const response = await axios.get('user/getUserDevices');
	  console.log('API Response>>>>>:', response.data);
	  return response.data;
	}
  );

  export const getCompanyOfficeMaster = createAsyncThunk(
	'user/getCompanyOfficeMaster',
	async () => {
	  const response = await axios.get('user/getCompanyOfficeMaster');
	  console.log('API Response>>>>>:', response.data);
	  return response.data;
	}
  );
  



export const addUser = createAsyncThunk("user/addUser", async (values) => {
	try {
		const { data } = await axios({
			method: "post",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=UTF-8",
			},
			url: `user/login`,
			data: {
				...values,
			},
		});
		localStorage.setItem("access-token", data.token);
		localStorage.setItem("role", data.role);
		localStorage.setItem("roleId", data.roleId);
		localStorage.setItem("user", data.userName);
		localStorage.setItem("id", data.id);
		localStorage.setItem("isLogged", true);
		localStorage.setItem("company_id", data.company_id);
		localStorage.setItem("requirePasswordChange", data.requirePasswordChange);
		toast.success(" Login Successfully Done");
		console.log("hh", data)

		return {
			data,
			message: "success",
		};
	} catch (error) {
		console.log(error.message);
		toast.error("Incorrect Username or Password !");
		return {
			message: "error",
		};
	}
});

// Update User Information

export const updateUser = createAsyncThunk(
	"user/updateUser",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",
				url: `user/${id}`,
				data: {
					...values,
				},
			});
			toast.success("User Information Updated Successfully");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			console.log(error.message);
			toast.error("Error in updating user information");
			return {
				message: "error",
			};
		}
	}
);

export const updateBankDetails = createAsyncThunk(
	"user/updateBankDetails",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",
				url: `user/bankDetails/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Bank Details Updated Successfully");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			console.log(error.message);
			toast.error("Error in updating Bank Details");
			return {
				message: "error",
			};
		}
	}
);

// Add this to your userSlice
export const removeBiometric = createAsyncThunk(
	"user/removeBiometric",
	async (id) => {
	  try {
		const response = await axios.delete(`user/removeBiometric/${id}`);
		toast.success("Biometric data removed successfully");
		return id; // Return the ID of the removed biometric
	  } catch (error) {
		toast.error("Error removing biometric data");
		console.log(error.message);
		return Promise.reject(error.message);
	  }
	}
  );
  
  


const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		clearUser: (state) => {
			state.user = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for loadAllStaff ======

		builder.addCase(loadAllStaff.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAllStaff.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(loadAllStaff.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 1) ====== builders for getCompanyOfficeMaster ======

		builder.addCase(getCompanyOfficeMaster.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getCompanyOfficeMaster.fulfilled, (state, action) => {
			state.loading = false;
			state.officeName = action.payload;
		});

		builder.addCase(getCompanyOfficeMaster.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
		

		// 2) ====== builders for addStaff ======

		builder.addCase(addStaff.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addStaff.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addStaff.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for uploadUsersFromExcel ======

		builder.addCase(uploadUsersFromExcel.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(uploadUsersFromExcel.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(uploadUsersFromExcel.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2.1) ====== builders for addIndivisualUser ======

		builder.addCase(addIndivisualUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addIndivisualUser.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addIndivisualUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2.1) ====== builders for changePasswordToAdmin ======

		builder.addCase(changePasswordToAdmin.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(changePasswordToAdmin.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(changePasswordToAdmin.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2.1) ====== builders for postBankDetails ======

		builder.addCase(postBankDetails.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(postBankDetails.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(postBankDetails.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2.2) ====== builders for changePassword ======

		builder.addCase(changePassword.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(changePassword.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(changePassword.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for addUser ======

		builder.addCase(addUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addUser.fulfilled, (state, action) => {
			state.loading = false;

			if (!Array.isArray(state.user)) {
				state.user = [];
			}
			const user = [...state.user];
			user.push(action.payload.data);
			state.user = user;
		});

		builder.addCase(addUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for updateUser ======

		builder.addCase(updateUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateUser.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for loadSingleStaff ======

		builder.addCase(loadSingleStaff.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadSingleStaff.fulfilled, (state, action) => {
			state.loading = false;

			state.user = action.payload.data;
		});

		builder.addCase(loadSingleStaff.rejected, (state, action) => {
			state.loading = false;
			console.log(action.payload);
			state.error = action.payload.message;
		});

		// 4) ====== builders for getBankDetailsByUserId ======

		builder.addCase(getBankDetailsByUserId.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getBankDetailsByUserId.fulfilled, (state, action) => {
			state.loading = false;

			state.user = action.payload.data;
		});

		builder.addCase(getBankDetailsByUserId.rejected, (state, action) => {
			state.loading = false;
			console.log(action.payload);
			state.error = action.payload.message;
		});

		// 4) ====== builders for getCompanyNameByClientId ======

		builder.addCase(getCompanyNameByClientId.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getCompanyNameByClientId.fulfilled, (state, action) => {
			state.loading = false;

			state.companyName = action.payload.data;
		});

		builder.addCase(getCompanyNameByClientId.rejected, (state, action) => {
			state.loading = false;
			console.log(action.payload);
			state.error = action.payload.message;
		});

		// 5) ====== builders for loadTodaysBirthdays ======

		builder.addCase(loadTodaysBirthdays.pending, (state) => {
			state.loading = true
		});

		builder.addCase(loadTodaysBirthdays.fulfilled, (state, action) => {
			const bday = action.payload
			console.log("todaybirthday", bday)
			state.loading = false;
			state.todaysBirthdays = action.payload;
		});

		builder.addCase(loadTodaysBirthdays.rejected, (state, action) => {
			state.loading = false;
			console.log(action.payload);
			state.error = action.payload.message;
		});

		// 6) ====== builders for loadUpcomingBirthdays ======

		builder.addCase(loadUpcomingBirthdays.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadUpcomingBirthdays.fulfilled, (state, action) => {
			const upcomingbday = action.payload
			console.log("upcomingbday", upcomingbday)
			state.loading = false;
			state.upcomingBirthdays = action.payload;
		});

		builder.addCase(loadUpcomingBirthdays.rejected, (state, action) => {
			state.loading = false;
			console.log(action.payload);
			state.error = action.payload.message;
		});

		// 6) ====== builders for getUserDevices ======

		builder.addCase(getUserDevices.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getUserDevices.fulfilled, (state, action) => {
            state.loading = false;
            state.userDeviceDetails = action.payload;
            state.total = action.payload.length;  // Adjust this if necessary
        });

		builder.addCase(getUserDevices.rejected, (state, action) => {
			state.loading = false;
			console.log(action.payload);
			state.error = action.payload.message;
		});


		// 7) ====== builders for deleteStaff ======

		builder.addCase(deleteStaff.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteStaff.fulfilled, (state, action) => {
			state.loading = false;

			const filterUser = state.list.filter(
				(staff) => staff.id !== parseInt(action.payload) && staff
			);

			state.list = filterUser;
		});

		builder.addCase(deleteStaff.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 8) ====== builders for removeBiometric ======

		// Add this to the extraReducers in your userSlice
builder.addCase(removeBiometric.pending, (state) => {
	state.loading = true;
  });
  
  builder.addCase(removeBiometric.fulfilled, (state, action) => {
	state.loading = false;
	state.userDeviceDetails = state.userDeviceDetails.filter(
	  (device) => device.userDeviceId !== action.payload
	);
  });
  
  builder.addCase(removeBiometric.rejected, (state, action) => {
	state.loading = false;
	state.error = action.payload;
  });
  
	},
});

export default userSlice.reducer;
export const { clearUser } = userSlice.actions;
